import useOffClick from '@flight-workspace/common-client/src/hooks/useOffClick';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function Notice({
  areaCode,
  onClickBooking,
  onClose,
}: {
  areaCode: string;
  onClickBooking: (event: React.MouseEvent<Element, MouseEvent>) => void;
  onClose: () => void;
}) {
  const ref = useOffClick(onClose, { stopPropagation: true });

  return (
    <div className={cx('Notice')} aria-modal="true">
      <div className={cx('modal')} ref={ref}>
        <h5 className={cx('title')}>해외여행사 이용 시 주의사항</h5>
        <b className={cx('subtitle')}>최종 결제 금액을 꼭 확인해주세요.</b>
        <p className={cx('txt')}>
          카드사 수수료가 추가될 수 있습니다.
          <br />
          <span className={cx('desc')}>
            해외원화결제 차단 서비스 이용 여부, 결제 카드사 정책 등에 따라
            발생한 부가 수수료는 카드사로 문의해주세요.
          </span>
        </p>
        <p className={cx('txt')}>
          환율에 따라 네이버 원화 금액과 차이가 발생할 수 있습니다.
        </p>
        <b className={cx('subtitle')}>환불 및 변경 조건을 꼭 읽어주세요.</b>
        <p className={cx('txt')}>
          옵션에 따라 항공권 환불이 불가하거나, 환불 금액이 여행사 적립금으로
          지급될 수 있습니다.
        </p>
        <p className={cx('txt')}>
          항공 스케쥴 변경 혹은 취소에 대한 보상이 불가할 수 있습니다.
        </p>
        <div className={cx('btns')}>
          <button
            className={cx('cancel')}
            type="button"
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.globalotacancle`}
            onClick={onClose}
          >
            취소
          </button>
          <button
            className={cx('confirm')}
            type="button"
            data-event-nlog="click"
            data-event-area-code={`${areaCode}.globalotabook`}
            onClick={onClickBooking}
          >
            예약 계속하기
          </button>
        </div>
        <button
          className={cx('close')}
          type="button"
          data-event-nlog="click"
          data-event-area-code={`${areaCode}.globalotacancle`}
          onClick={onClose}
        />
      </div>
    </div>
  );
}
